<template>
  <div class="reward-rules">
    <p class="rule-details">{{$t('rule_details')}}</p>
    <div class="rule-table">
      <table>
        <caption>{{$t('table_head')}}</caption>
        <tr>
          <th>{{$t('device_number')}}</th>
          <th>{{$t('month_package')}}</th>
          <th>{{$t('quarter_package')}}</th>
          <th>{{$t('year_package')}}</th>
        </tr>
        <tr>
          <td>1</td>
          <td>5</td>
          <td>10</td>
          <td>30</td>
        </tr>
        <tr>
          <td>2</td>
          <td>10</td>
          <td>20</td>
          <td>45</td>
        </tr>
        <tr>
          <td>3</td>
          <td>15</td>
          <td>30</td>
          <td>60</td>
        </tr>
        <tr>
          <td>5</td>
          <td>25</td>
          <td>45</td>
          <td>90</td>
        </tr>
        <tr>
          <td>10</td>
          <td>45</td>
          <td>90</td>
          <td>120</td>
        </tr>
        <tr>
          <td>20</td>
          <td>45</td>
          <td>90</td>
          <td>120</td>
        </tr>
        <tr>
          <td>40</td>
          <td>45</td>
          <td>90</td>
          <td>120</td>
        </tr>
        <tr>
          <td>60</td>
          <td>45</td>
          <td>90</td>
          <td>120</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
  import locales from './lang.js'

  export default {
    name: 'reward-rules',
    locales
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  * {
    padding: 0;
    margin: 0;
  }

  .reward-rules {
    background: #fff;
    max-width: 1080px;
    margin: .5rem auto;
    padding: 0 .4rem;
    text-align: left;
    @media (max-width: 767px) {
      padding: .4rem .2rem;
      margin: 0 auto;
    }
  }
  p{
    font-size: .14rem;
    color: #333333;
    letter-spacing: 0;
    line-height: .3rem;
  }
  .rule-table {
    text-align: center;
    margin: .5rem 0 0;
    table {
      width: 100%;
      border: 1px solid #333333;
      caption {
        text-align: center;
        color: #333333;
      }
      caption, th, td {
        border: 1px solid #333333;
        border-bottom: none;
        padding: .08rem;
        text-align: center;
        font-size: .14rem;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// rewardRules.vue?b96adf98